import { render } from "./deployToken.vue?vue&type=template&id=ada07bcc&scoped=true"
import script from "./deployToken.vue?vue&type=script&lang=js"
export * from "./deployToken.vue?vue&type=script&lang=js"

import "./deployToken.vue?vue&type=style&index=0&id=ada07bcc&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/dbc-website-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ada07bcc"]])

export default __exports__